import React from "react";

import { createRoot } from "react-dom/client";

import { AppLoader, AppLoadingSplashScreen, isBrowserSupported, UnsupportedBrowser } from "@mil/optimax-web-base";

import { SplashScreenTitleWithLogo } from "./SplashScreenTitleWithLogo";

// The following CSS rules are the minimal required to show the splash screen.
// Everything else will be loaded later with the App component.
import "@mil/optimax-web-base/lib/src/assets/less/critical.less"; // Critical CSS rules we need immediately with the splash screen

// Get the root container where the app will be rendered
const rootElement = document.getElementById("react-root-container");
if (rootElement === null) {
    throw new Error(`The root element can not be null`);
}
const root = createRoot(rootElement);

if (isBrowserSupported()) {
    root.render(
        <AppLoader
            lazyLoader={() => import(/* webpackChunkName: "app" */ "./App")}
            splashScreen={<AppLoadingSplashScreen title={<SplashScreenTitleWithLogo />} />}
        />,
    );
} else {
    root.render(<UnsupportedBrowser />);
}
